import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { shippingTermRepository } from '../data-access/repositories/ShippingTermRepository'

const base = ['vendor', 'shipping-term']

export const shippingTermQueryConfig = {
  all: () => ({
    queryKey: buildQueryKey(base),
  }),
  list: (params?: RepoFilterParams) => ({
    queryKey: buildQueryKey([...base, 'list', params]),
    queryFn: () => shippingTermRepository.list(params),
  }),
}
